<div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-file-import" aria-hidden="true"></i> Importer faste data</h5>
    <button type="button" class="btn-close" aria-label="Luk" [disabled]="importing()"
        (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body" style="min-height: 280px;">
    @if (result(); as result) {
    <div class="alert alert-success" role="alert">
        <h5 class="alert-heading"><i class="fa-solid fa-circle-check" aria-hidden="true"></i> Import succesfuld</h5>
        <hr>
        <p class="mb-2">{{ result.message }}.</p>
        <ul class="mb-0">
            @for (table of result.tables; track table.tableName) {
            <li><code>{{ displayName(table.tableName) }}</code>@if (table.scope) { ({{ table.scope }})}: {{ table.rowCount }} rækker</li>
            }
        </ul>
    </div>
    } @else if (importing()) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 240px">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Importerer faste data</h4>
    </div>
    } @else if (preview.isLoading()) {
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 240px">
        <div class="spinner-border" role="status"><span class="visually-hidden">Indlæser...</span></div>
        <p class="mt-2 mb-0">Tæller rækker i begge miljøer...</p>
    </div>
    } @else if (preview.error()) {
    <div class="alert alert-danger" role="alert">
        <h5 class="alert-heading">Kunne ikke hente forhåndsvisning</h5>
        <hr>
        <p class="mb-2">Rækketallene fra det forrige miljø kunne ikke hentes. Importen er ikke kørt.</p>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="preview.reload()">Prøv igen</button>
    </div>
    } @else if (preview.value(); as preview) {
    <p>
        Tabellerne nedenfor <strong>tømmes</strong> i <strong>{{ preview.targetEnvironment }}</strong> og erstattes 1:1
        med indholdet fra <strong>{{ preview.sourceEnvironment }}</strong>. Kildens Id'er bevares. Handlingen kan ikke fortrydes.
    </p>
    <p>
        For <code>Administration.ViewOpsaetning</code> erstattes kun de globale rækker (<code>KundeId = 0</code>) med nye Id'er;
        kundernes egne visningsopsætninger røres ikke.
    </p>
    <table class="table table-sm align-middle mb-0">
        <thead>
            <tr>
                <th scope="col">Tabel</th>
                <th scope="col" class="text-end">Rækker i {{ preview.sourceEnvironment }}</th>
                <th scope="col" class="text-end">Erstattes i {{ preview.targetEnvironment }}</th>
            </tr>
        </thead>
        <tbody>
            @for (table of preview.tables; track table.tableName) {
            <tr>
                <td>
                    <code>{{ displayName(table.tableName) }}</code>
                    @if (table.scope) {
                    <small class="text-body-secondary ms-1">kun {{ table.scope }}</small>
                    }
                </td>
                <td class="text-end">{{ table.sourceCount }}</td>
                <td class="text-end">{{ table.targetCount }}</td>
            </tr>
            }
        </tbody>
    </table>
    @if (error(); as error) {
    <div class="alert alert-danger mt-3 mb-0" role="alert">
        <h6 class="alert-heading">Import fejlede</h6>
        <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{ error }}</pre>
    </div>
    }
    }
</div>

<div class="modal-footer">
    @if (result()) {
    <button type="button" class="btn btn-primary" (click)="activeModal.close('imported')">Luk</button>
    } @else {
    <button type="button" class="btn btn-secondary" [disabled]="importing()"
        (click)="activeModal.dismiss('Cancel')">Annuller</button>
    <button type="button" class="btn btn-danger" [disabled]="importing() || !preview.hasValue()" (click)="import()">
        <i class="fas fa-file-import" aria-hidden="true"></i> {{ error() ? 'Prøv igen' : 'Tøm og importer' }}
    </button>
    }
</div>
